export * from './configs.model';
export * from './img-data.model';
export * from './tab-menu.model';
